import { render, staticRenderFns } from "./selectPatient.vue?vue&type=template&id=2edbfacc&scoped=true&"
import script from "./selectPatient.vue?vue&type=script&lang=js&"
export * from "./selectPatient.vue?vue&type=script&lang=js&"
import style0 from "./selectPatient.vue?vue&type=style&index=0&id=2edbfacc&rel=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edbfacc",
  null
  
)

export default component.exports